import { render } from "./VendorPayments.vue?vue&type=template&id=baf2fec8"
import script from "./VendorPayments.vue?vue&type=script&lang=js"
export * from "./VendorPayments.vue?vue&type=script&lang=js"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__